import { TablePagination as MuiTablePagination, useTheme } from '@mui/material';

export const DefaultTablePagination = ({
  totalCount,
  currentPage,
  pageSize,
  pageSizes,
  onCurrentPageChange,
  onPageSizeChange,
}: any) => {
  const { palette } = useTheme();

  return (
    // dev-express renders the paging panel inside a <div>, so the default
    // TableCell root would put a <td> outside of any table.
    <MuiTablePagination
      component="div"
      style={{
        // The pager shares a flex column with the scrolling rows. MUI gives its root overflow: auto,
        // which lets flex shrink it to nothing, so on a short window the rows took its height and
        // only a sliver of the pager showed. The rows scroll; the pager keeps its height.
        flexShrink: 0,
        borderBottom: 'none',
        backgroundColor: palette.background.tableHeader,
        paddingRight: '5rem',
      }}
      count={Number(totalCount)}
      page={Number(currentPage)}
      rowsPerPage={Number(pageSize)}
      rowsPerPageOptions={pageSizes}
      onPageChange={(_event, newPage) => onCurrentPageChange(newPage)}
      onRowsPerPageChange={(event) => onPageSizeChange(event.target.value)}
    />
  );
};
